import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Container, Col, Row, ButtonGroup, Button, Modal } from 'react-bootstrap'

import { NCM, CEST, CFOP, ICMS, IPI, PIS, SelectICMS } from '@taxes'
import { setNcm, setCest, setCfop, setIcms, setIpi, setPis } from '@taxes/actions'
import {
  setBaseProductName,
  setBaseProductBarcode,
  setBaseProductPrice,
  setBaseProductCost,
  setBaseProductInternalCode,
  setUnit,
  setCategorie,
  setMaskPrice,
  setMaskCost,
  clearProductInputs
} from './actions'

//import translate from '../product/product-base/translate.json'
//const productLabels = translate[navigator.language];

import ProductModel from '../../../../models/base/product'
import { getBranchOwner, api, post } from '@config'
import { getProduct } from '../utils'

import ProductStock from './stock'
import ProductBase from './product-base'

const productM = new ProductModel()

import { setLoading } from "@inspinia-react/actions"
import { notification } from 'antd';

function ProductStockInfo(props) {
  return <ul className="list-group">
    <li className="list-group-item">
      Quantidade em estoque: {props.stock.quantity}
    </li>
    <li className="list-group-item">
      Valor em estoque: R$ {
        (props.sellable.price * props.stock.quantity).toFixed(2)
      }
    </li>
    <li className="list-group-item">
      <button className="btn btn-primary btn-sm" onClick={props.openModal}>
        gerenciar
      </button>
    </li>
  </ul>
}

function ProductTaxes(props) {
  return <Col>
    <div className="py-2">
      <NCM />
    </div>
    <div className="py-2">
      <CFOP />
    </div>
    <div className="py-2">
      <SelectICMS />
    </div>
    <div className="py-2">
      <CEST />
    </div>
      <div className="py-2">
        <IPI as="select" />
      </div>
    {props.branch.crt === 2 || props.branch.crt === 1 ? "" : <div>
      <div className="py-2">
        <PIS />
      </div>
    </div>}
    <div className="py-2">
      <p className="lead">
        Estoque
      </p>
      <ProductStockInfo openModal={props.openModal} stock={props.stock} sellable={props.sellable} />

    </div>
  </Col>
}

class BaseProduct extends React.Component {
  constructor(props) {
    super(props)
    this.branch = getBranchOwner()
    this.state = {
      edit: false,
      maskPrice: '',
      maskCost: '',
      sellable: '',
      initialCode: null,
      stock: {},
      stockQuantity: '',
      modalStockManagement: false,
      stockDescreaseReasonInput: '',
      managerStockType: '2',
      product_id: '',

      modalErrList: "",
    }
    this.save = this.save.bind(this)
    this.cancel = this.cancel.bind(this)
    this.initProduct = this.initProduct.bind(this)
    this.handleChangeStockManagmentType = this.handleChangeStockManagmentType.bind(this)
    this.updateStockQuantity = this.updateStockQuantity.bind(this)
    this.closeModalStock = this.closeModalStock.bind(this)
  }
  initProduct(productValue) {
    const { id: product_id, sellable, fiscal_data, stock } = productValue
    const { ncm, cfop } = fiscal_data


    this.setState({ ...this, initialCode: sellable.code, stock, sellable, product_id })

    this.props.setBaseProductName(sellable.name)
    this.props.setBaseProductPrice(sellable.price)
    this.props.setMaskPrice(sellable.price)
    this.props.setBaseProductCost(sellable.cost)
    this.props.setMaskCost(sellable.cost)
    this.props.setBaseProductBarcode(sellable.barcode)
    this.props.setBaseProductInternalCode(sellable.code)
    sellable.unit_branch["value"] = sellable.unit_branch.id
    sellable.unit_branch["label"] = sellable.unit_branch.name
    this.props.setUnit(sellable.unit_branch)
    this.props.setCategorie(sellable.category)

    if (ncm && cfop) {
      this.props.setNcm(fiscal_data.ncm)
      this.props.setCest(fiscal_data.cest)
      this.props.setCfop(fiscal_data.cfop)
      this.props.setIcms(fiscal_data.template_icms)
      this.props.setIpi(fiscal_data.template_ipi)
      this.props.setPis(fiscal_data.template_pis)
    } else {
      this.save()
    }
    productM.data.id = productValue.id
    productM.obj = true
  }

  UNSAFE_componentWillMount() {
    this.props.setLoading(true)
    const id = window.location.pathname.split("/product/")[1]
    getProduct(id, p => {
      this.initProduct(p)
      this.props.setLoading(false)
    })
  }

  cancel() {
    window.history.back()
  }
  save() {
    productM.initFromProps(this.props)
    const success = product => {
      setTimeout(() => {
        notification.open({
          message: "Atualizado com sucesso",
          type: "success",
          key: 34,
          duration: 3
        })
      }, 1000);
      window.location.href = "/products"
    }
    productM.save(success)
  }
  handleChangeStockManagmentType(e) {
    this.setState({ ...this, managerStockType: e.target.value })
  }
  updateStockQuantity() {
    const { product_id, stockQuantity, managerStockType, stockDescreaseReasonInput } = this.state
    if (!stockQuantity) {
      document.querySelector("[data-stock-input-quantity]").classList.add("error")
      return
    }
    document.querySelector("[data-stock-input-quantity]").classList.remove("error")

    if (managerStockType === "3" && !stockDescreaseReasonInput) {
      document.querySelector("[data-stock-input-reason]").classList.add("error")
      return
    }
    if (managerStockType === "3") {
      document.querySelector("[data-stock-input-reason]").classList.remove("error")
    }

    this.props.setLoading(true)

    const url = `${api.stock.stocks}?branch_owner=${getBranchOwner().id}`;
    const data = {}
    data.product_id = product_id
    data.quantity = stockQuantity
    data.stock_history = {}
    data.stock_history.type = managerStockType
    data.stock_history.reason = stockDescreaseReasonInput
    const payload = stock => {
      this.props.setLoading(false)
      this.setState({ ...this, stock })
      this.closeModalStock()
      notification.open({
        message: "Estoque atualizado",
        type: "success",
        key: 9,
        duration: 4
      })
    }

    const errorPayload = err => {
      this.props.setLoading(false)
      console.log(err)
      const errors = this.getErrors(JSON.parse(err.response))
      this.setState({ ...this, modalErrList: errors })
    }


    post(url, data, payload, errorPayload)
  }

  getErrors(response) {
    let list = []
    if (!response.non_field_errors.length) return ["Erro"]

    for (let i = 0; i < response.non_field_errors.length; i++) {
      const element = response.non_field_errors[i]

      if (element.includes("Is not possible decrease a stock quantit")) {
        list.push("Quantidade insuficiente.")
      }

    }

    return list
  }

  closeModalStock() {
    this.setState({ ...this, modalStockManagement: false, managerStockType: '2', stockDescreaseReasonInput: '', stockQuantity: '' })
  }
  render() {
    return <Container className="py-2">
      <h1>Editar Produto Nº{this.state.sellable.internal_code}</h1>
      <Row>
        <Col>
          <ProductBase maskPrice={this.price} edit={this.state.edit} />
          {!this.branch.is_fiscal ? <div className="py-2">
            <p className="lead">
              Estoque
          </p>
            <ProductStockInfo
              openModal={() => this.setState({ ...this, modalStockManagement: true })}
              stock={this.state.stock}
              sellable={this.state.sellable} />

          </div> : <div />}
        </Col>
        {this.branch.is_fiscal
          ? <ProductTaxes
            openModal={() => this.setState({ ...this, modalStockManagement: true })}
            sellable={this.state.sellable}
            branch={this.branch}
            stock={this.state.stock}
          />
          : null}
      </Row>
      <ButtonGroup className="w-100">
        <Button onClick={this.cancel} variant="danger" className="w-50">
          Cancelar
      </Button>
        <Button onClick={this.save} className="w-50">
          Salvar
      </Button>
      </ButtonGroup>
      <Modal show={this.state.modalStockManagement}>
        <Modal.Header>
          <h3>
            Gerenciar estoque de produto
          </h3>
        </Modal.Header>
        <Modal.Body>
          <p className="lead">
            {this.state.sellable.name ? this.state.sellable.name.substring(0, 30) : this.state.sellable.name}
          </p>

          <div className="form-group">
            <p>
              Informe a Quantidade *
            </p>
            <input
              disabled={this.props.loading}
              className="form-control"
              data-stock-input-quantity
              placeholder={`Quantidade atual: ${this.state.stock.quantity || ''}`}
              value={this.state.stockQuantity}
              onChange={e => this.setState({ ...this, stockQuantity: e.target.value })} />
          </div>


          {
            this.state.managerStockType === "3"
              ? <React.Fragment>
                <div className="form-group">
                  <p>Informa o motivo da saída *: </p>
                  <input
                    disabled={this.props.loading}
                    data-stock-input-reason
                    className="form-control"
                    placeholder="Ex: venda"
                    value={this.state.stockDescreaseReasonInput}
                    onChange={e => this.setState({ ...this, stockDescreaseReasonInput: e.target.value })} />
                </div>
              </React.Fragment>
              : <div />
          }
          <p className="lead">
            Tipo:
          </p>

          <span className="text-danger mt-2 pb-3">* Obrigatório</span>
          <select
            disabled={this.props.loading}
            onChange={this.handleChangeStockManagmentType}
            className="form-control">
            {
              this.state.stock.quantity === null
                ? <option value="1">
                  Iniciar Estoque
                </option>
                : <div />
            }
            <option value="2">
              Entrada manual
              </option>
            <option value="3">
              Saída manual
              </option>
          </select>
          {this.state.modalErrList ? <div className='pt-3'>
            <ul>{this.state.modalErrList.map(e => <li className='text-danger h6'>{e}</li>)}</ul>
          </div> : ""}
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Button
              disabled={this.props.loading}
              onClick={this.closeModalStock}
              variant="danger">
              Cancelar
            </Button>
            <Button
              disabled={this.props.loading}
              onClick={this.updateStockQuantity}
              variant="primary">
              Concluir
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    </Container>
  }
  componentWillUnmount() {
    this.props.clearProductInputs()
  }
}

const mapStateToProps = state => ({
  loading: state.loading,
  barcode: state.baseProductBarcode,
  name: state.baseProductName,
  code: state.baseProductInternalCode,
  cost: state.baseProductCost,
  price: state.baseProductPrice,
  unit: state.unit,
  initialStock: state.initialStock,
  category: state.category,
  maskPrice: state.maskPrice,

  ncm: state.ncm,
  cest: state.cest,
  cfop: state.cfop,
  icms: state.icms,
  pis: state.pis,
  ipi: state.ipi
});

const mapDispatchToProps = disptch => bindActionCreators({
  setBaseProductName,
  setBaseProductBarcode,
  setBaseProductPrice,
  setBaseProductCost,
  setBaseProductInternalCode,
  setUnit,
  setCategorie,
  setMaskPrice,
  setMaskCost,
  setLoading,

  setNcm, setCest, setCfop, setIcms,
  setIpi, setPis,

  clearProductInputs
}, disptch);

export default connect(mapStateToProps, mapDispatchToProps)(BaseProduct)



// WEBPACK FOOTER //
// ./src/components/pages/products/base/edit.jsx